
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api"; // Your shared axios instance
import { hideLoader, showLoader } from "./loaderSlice";

export const getRoleList = createAsyncThunk(
  "getRoleList",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(`/getall/clinic/roles`);

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch roles");
    }
  }
);

export const createRole = createAsyncThunk(
  "createRole",
  async ({ roleName }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/clinic/role?type=role&roleName=${roleName}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to create role");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const updateRole = createAsyncThunk(
  "updateRole",
  async ({ roleId, roleName }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/clinic/role/${roleId}?type=role&roleName=${roleName}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to update role");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "deleteRole",
  async ({ roleId }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/clinic/role/${roleId}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return roleId; // Return ID to remove from list
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to delete role");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const roleSlice = createSlice({
  name: "role",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRoleList.fulfilled, (state, action) => {
        state.list = action.payload ?? [];
        state.loading = false;
        state.error = null;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.loading = false;
        state.error = null;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.list.findIndex((r) => r.roleId === updated.roleId);
        if (index !== -1) {
          state.list[index] = updated;
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        const id = action.payload;
        state.list = state.list.filter((r) => r.roleId !== id);
        state.loading = false;
        state.error = null;
      })
      .addCase(getRoleList.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoleList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching roles.";
      });
  },
});

export default roleSlice.reducer;